import { useSearchParams, Navigate } from "react-router-dom";
import { Layout } from "../components/Navbar";
import { getUser } from "../api";
import { ClinicalDocEditor } from "../components/ClinicalDocEditor";

// Pagina editor a sé (usata dal Videoconsulto: apertura in nuova scheda, senza interrompere la chiamata).
export default function ClinicalDocEditorPage() {
  const [sp] = useSearchParams();
  const me = getUser();
  if (!me) return <Navigate to="/login" replace />;
  if (me.role !== "professional" && me.role !== "organization") return <Navigate to="/" replace />;

  const folderId = sp.get("folder");
  const ctx = folderId ? { folderId } : {
    episode: {
      patient_id: sp.get("patient") || undefined,
      episode_type: sp.get("type") || "documento",
      vc_id: sp.get("vc") || undefined,
      booking_id: sp.get("booking") || undefined,
      service_id: sp.get("service") || undefined,
      event_id: sp.get("event") || undefined,
      name: sp.get("name") || undefined,
      date: sp.get("date") || undefined,
    },
  };
  const close = () => { try { if (window.opener) { window.close(); return; } } catch { /* noop */ } window.history.back(); };

  return (
    <Layout>
      <div className="yp-container py-8">
        <h1 className="text-2xl font-bold mb-4">Documento clinico</h1>
        <ClinicalDocEditor ctx={ctx} embedded onClose={close} onSaved={close} />
      </div>
    </Layout>
  );
}
